// extracted by mini-css-extract-plugin
export default {"accordianContainer":"P3bDRsHk","tileContainer":"v5rVUjIJ","descriptionContainer":"OhWFnJtW","actionButton":"auYBzifd","icon":"tgHgqf52"};